import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { login, formatApiErrorDetail } from "./AdminAuth";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim(), password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="flex min-h-screen items-center justify-center bg-deep-brown px-6"
      data-testid="admin-login-page"
    >
      <div className="w-full max-w-md">
        <div className="mb-10 text-center">
          <p className="font-sans text-[11px] uppercase tracking-[0.4em] text-bronze-light">Private</p>
          <h1 className="mt-4 font-sans text-3xl font-light uppercase tracking-[0.25em] text-white">
            Dashboard
          </h1>
          <p className="mt-3 font-sans text-[11px] uppercase tracking-[0.3em] text-[#F1E6D7]/40">
            James Green · eXp Luxury
          </p>
        </div>

        <form onSubmit={submit} className="border border-white/10 bg-ink/40 p-8 backdrop-blur-sm">
          <div className="mb-6">
            <label className="mb-2 block font-sans text-[10px] uppercase tracking-[0.3em] text-bronze-light">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="admin-login-email"
              className="w-full border-b border-white/20 bg-transparent pb-2 font-light text-[#F1E6D7] outline-none transition-colors focus:border-bronze-light"
              placeholder="you@exprealty.com"
            />
          </div>
          <div className="mb-8">
            <label className="mb-2 block font-sans text-[10px] uppercase tracking-[0.3em] text-bronze-light">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-login-password"
              className="w-full border-b border-white/20 bg-transparent pb-2 font-light text-[#F1E6D7] outline-none transition-colors focus:border-bronze-light"
              placeholder="••••••••"
            />
          </div>

          {error && (
            <p className="mb-6 font-sans text-[12px] text-red-300/90" data-testid="admin-login-error">
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="flex w-full items-center justify-center gap-3 bg-bronze/90 px-8 py-3.5 font-sans text-[11px] uppercase tracking-[0.3em] text-[#F1E6D7] transition-all duration-500 hover:bg-bronze disabled:opacity-50"
          >
            <Lock size={14} />
            {loading ? "Signing in…" : "Enter Dashboard"}
          </button>
        </form>
      </div>
    </div>
  );
}
